import type { ReactElement } from "react"
import type { Control, FieldPath, FieldValues } from "react-hook-form"
import { useController } from "react-hook-form"

import type { AerosTextFieldProps } from "../AerosTextField"
import { AerosTextField } from "../AerosTextField"

interface FormTextFieldProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends Omit<AerosTextFieldProps, "name" | "defaultValue" | "onChange"> {
  control: Control<TFieldValues>
  name: TName
  onChange?: (value: string) => void
}

export const FormTextField = <TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  helperText,
  onChange,
  ...props
}: FormTextFieldProps<TFieldValues, TName>): ReactElement => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  })

  const handleChange = (value: string) => {
    field.onChange(value)
    onChange?.(value)
  }

  return (
    <AerosTextField
      {...props}
      {...field}
      onChange={handleChange}
      error={!!error}
      helperText={error?.message ?? helperText}
    />
  )
}
